<template>
  <div>
    <b-container fluid class="d-flex justify-content-center">
      <VueApexCharts
        width="450"
        :options="data.chartOptions"
        :series="series"
      />
    </b-container>
  </div>
</template>
<script>
import helpers from "@/common/utils/helpers";
import VueApexCharts from "vue-apexcharts";
import DashboardAdminService from "@/common/services/dashboards/dashboard_admin.service";
export default {
  components: {
    VueApexCharts,
  },
  data: () => ({
    dados: [],
    data: {
      chartOptions: {
        chart: {
          width: 450,
          type: "donut",
        },
        labels: helpers.Segmento.map((item) => item.text),
        legend: {
          position: "bottom",
          customLegendItems: helpers.Segmento.map((item) => item.text),
        },
      },
    },
  }),
  methods: {
    buscar: function () {
      DashboardAdminService.empresasPorSegmento().then((response) => {
        this.dados = response.data.data;
      });
    },
  },
  mounted() {
    this.buscar();
  },
  computed: {
    total: function () {
      return this.dados.reduce((total, item) => {
        return total + item.empresas.length;
      }, 0);
    },
    series: function () {
      let value = [];
      helpers.Segmento.map((el) => {
        value.push(this.dados.filter((el2) => el2.segmento == el.value).length);
      });
      return value;
    },
  },
};
</script>
<style lang="">
</style>